import FetchedCorrectiveImageCard from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/correctiveImages/components/fetchedImages/components/fetchedCorrectiveImageCard/FetchedCorrectiveImageCard';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { getCulpritReceivedCorrectiveImagesOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritReceivedCorrectiveImages/getCulpritReceivedCorrectiveImagesOptions';
import WrapperCorrectiveImagesList from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/components/correctiveImages/WrapperCorrectiveImagesList/WrapperCorrectiveImagesList';
import { Box, Flex } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography';
import { postCulpritAcceptOrRejectReceivedImagesOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCulpritAcceptOrRejectRecievedImages/postCulpritAcceptOrRejectRecievedImagesOptions';
import NoRecievedImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/noRecievedImagesIcon.svg?react';
import { getCulpritVehicleCorrectiveImageTabsOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritVehicleCorrectiveImageTabs/getCulpritVehicleCorrectiveImageTabsOpions';
const FetchedCulpritCorrectiveImages = () => {
  const queryClient = useQueryClient();
  const { id } = useParams();
  const { data: fetchedData } = useQuery(
    getCulpritReceivedCorrectiveImagesOptions({ id: +id! }),
  );
  const { mutateAsync, isPending } = useMutation(
    postCulpritAcceptOrRejectReceivedImagesOptions(),
  );
  const revalidateApi = () => {
    queryClient.invalidateQueries({
      queryKey: getCulpritReceivedCorrectiveImagesOptions({ id: +id! })
        ?.queryKey,
    });
    queryClient.invalidateQueries({
      queryKey: getCulpritVehicleCorrectiveImageTabsOptions(+id!)?.queryKey,
    });
  };
  return fetchedData?.damaged?.length! > 0 ||
    fetchedData?.documents?.length! > 0 ||
    fetchedData?.vehicle?.length! > 0 ? (
    <Flex direction={'column'} gap={'2rem'} mt={16}>
      {fetchedData?.documents?.length! > 0 && (
        <WrapperCorrectiveImagesList headerTitle="مدارک فردی">
          {fetchedData?.documents.map((item) => (
            <FetchedCorrectiveImageCard
              image={item.image}
              key={item.id}
              title={item.title?.fa_const}
              accept={() =>
                mutateAsync({
                  data: {
                    accepted: true,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                }).then(() => revalidateApi())
              }
              reject={() =>
                mutateAsync({
                  data: {
                    accepted: false,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                }).then(() => revalidateApi())
              }
              acceptLoading={isPending}
              rejectLoading={isPending}
            />
          ))}
        </WrapperCorrectiveImagesList>
      )}
      {fetchedData?.vehicle?.length! > 0 && (
        <WrapperCorrectiveImagesList headerTitle="فیلم و تصاویر وسیله‌نقلیه">
          {fetchedData?.vehicle.map((item) => (
            <FetchedCorrectiveImageCard
              image={item.image}
              key={item.id}
              title={item.title?.fa_const}
              accept={() =>
                mutateAsync({
                  data: {
                    accepted: true,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                }).then(() => revalidateApi())
              }
              reject={() =>
                mutateAsync({
                  data: {
                    accepted: false,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                }).then(() => revalidateApi())
              }
              acceptLoading={isPending}
              rejectLoading={isPending}
            />
          ))}
        </WrapperCorrectiveImagesList>
      )}
      {fetchedData?.damaged?.length! > 0 && (
        <WrapperCorrectiveImagesList headerTitle="نقاط اسیب دیده">
          {fetchedData?.damaged.map((item) => (
            <FetchedCorrectiveImageCard
              image={item.image}
              key={item.id}
              title={item.title?.fa_const}
              accept={() =>
                mutateAsync({
                  data: {
                    accepted: true,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                }).then(() => revalidateApi())
              }
              reject={() =>
                mutateAsync({
                  data: {
                    accepted: false,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                }).then(() => revalidateApi())
              }
              acceptLoading={isPending}
              rejectLoading={isPending}
            />
          ))}
        </WrapperCorrectiveImagesList>
      )}
    </Flex>
  ) : (
    <Box
      w="100%"
      h="60vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={16}
    >
      <NoRecievedImagesIcon />
      <Typography color="black-3" textStyle="b2">
        تصویری دریافت نشده است !
      </Typography>
    </Box>
  );
};

export default FetchedCulpritCorrectiveImages;
